<template>
  <a-modal
    v-if="imgVisible"
    :title="title"
    :width="width"
    class="dialog"
    :visible="imgVisible"
    :footer="null"
    @cancel="cancel"
  >
    <div class="viewImg">
      <img :width="imgWidth" :src="previewImg" :alt="previewImg">
      <slot />
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'ViewImg',
  props: {
    title: {
      type: String,
      default: '查看图片'
    },
    imgWidth: {
      type: String,
      default: '90%'
    },
    width: {
      type: Number,
      default: 720
    },
    imgVisible: {
      type: Boolean,
      default: false
    },
    previewImg: {
      type: String,
      default: ''
    }
  },
  methods: {
    cancel() {
      this.$emit('update:imgVisible', false)
    }
  }

}
</script>

<style rel="stylesheet/less" lang="less" scoped>
.viewImg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
